const LineMoreIcon = () => (
    <svg width="2" height="96" viewBox="0 0 2 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0L1 96" stroke="#8D8D8D" stroke-width="2" stroke-dasharray="12 8"/>
    </svg>
);

export default LineMoreIcon;